export function EmptyColumn() {
  return (
    <td className="text-onsurface/60 px-4 py-3 text-sm text-center">-</td>
  );
}